// /src/renderer/layout/TopMenu/withNavigation.tsx
import React from 'react';
import { useNavigate, NavigateFunction } from 'react-router-dom';

export interface InjectedNavigationProps {
  navigate: NavigateFunction;
}

function withNavigation<P extends object>(
  Component: React.ComponentType<P & InjectedNavigationProps>
): React.FC<P> {
  return (props: P) => {
    const navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
  };
}

export default withNavigation;
